module.exports = __webpack_public_path__ + "img/135x90-01.a3ce24ad.png";